import { all, takeLatest } from 'redux-saga/effects';

import { ChannelActionType } from './channels.actions';

function* setAllChannelsSaga() {
    yield takeLatest(ChannelActionType.SetAllChannels, function* () {
        try {
        } catch (e) {}
    });
}

export function* channelsSaga() {
    yield all([setAllChannelsSaga()]);
}
